import { useQuery } from "@apollo/client";

import {
  GET_COMPETITION_FEED,
  GET_COMPETITION_LEADERBOARD,
} from "MVVM/GraphQL/competitions";
import {
  ICompetitionFeedSubmission,
  ILeaderboardEntry,
} from "../../../Competitions/@types";

const CLIP_COUNT = 12;
const LEADERBOARD_PEEK = 5;

export const FeaturedCompetitionViewModel = (competitionId: string) => {
  const { data: feedData, loading: clipsLoading } = useQuery(
    GET_COMPETITION_FEED,
    {
      variables: { id: competitionId, first: CLIP_COUNT },
      fetchPolicy: "cache-and-network",
    },
  );

  const { data: leaderboardData, loading: leaderboardLoading } = useQuery(
    GET_COMPETITION_LEADERBOARD,
    {
      variables: { id: competitionId, limit: LEADERBOARD_PEEK },
      fetchPolicy: "cache-and-network",
    },
  );

  const submissions = [
    ...((feedData?.competitionFeed?.nodes ??
      []) as ICompetitionFeedSubmission[]),
  ].sort(
    (a, b) =>
      new Date(b.submittedAt).getTime() - new Date(a.submittedAt).getTime(),
  );

  const leaderboard = (leaderboardData?.competitionLeaderboard?.topEntries ??
    []) as ILeaderboardEntry[];

  return {
    submissions,
    clipsLoading,
    leaderboard,
    leaderboardLoading,
  };
};
